import { marked } from "marked";

marked.setOptions({
  gfm: true,
  breaks: true,
  headerIds: false,
  mangle: false,
});

export function markdownToHtml(value) {
  if (value == null) {
    return "";
  }

  const markdown = String(value).trim();

  if (!markdown) {
    return "";
  }

  return marked.parse(markdown);
}
